import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";
import { IntlSearchPayload, IntlSearchResult } from "../@types/intlFlightAggregator";

/**
 * Supplier-agnostic international flight search (Duffel <-> Travex).
 * Separate from useSearchFlights (Travex-only, /aviation/international/search)
 * — this targets the new aggregator endpoint, /aviation/international/v2/search.
 */
function useSearchInternationalOffers(
  options?: MutationOptions<APIResponse<IntlSearchResult>, APIError, IntlSearchPayload>
) {
  const {
    isLoading: searchingOffers,
    isError: isSearchError,
    error: searchError,
    mutate: searchOffers,
    data: searchResult,
  } = useMutation<APIResponse<IntlSearchResult>, APIError, IntlSearchPayload>(
    (payload: IntlSearchPayload) => {
      return post(API_URL + "/aviation/international/v2/search", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    options
  );

  return {
    searchOffers,
    searchResult,
    searchError,
    isSearchError,
    searchingOffers,
  };
}

export default useSearchInternationalOffers;
